<template>
  <div class="industry">
    <div class="menu">
      <el-menu
        :default-active="menuType.food"
        class="el-menu-vertical-demo"
        @select="handleSelect"
        @open="handleOpen"
        @close="handleClose"
      >
        <el-menu-item :index="menuType.food">
          <span slot="title">美食推荐</span>
        </el-menu-item>
        <el-menu-item :index="menuType.special">
          <span slot="title">特色产品</span>
        </el-menu-item>
        <el-submenu :index="menuType.travel">
          <template slot="title">景区推荐</template>
          <el-menu-item :index="menuType.route_one">推荐线路1</el-menu-item>
          <!-- ：强家老醋文化养生园—牛家坊村→桃园农庄→牛家大院→依林小镇→海军生态农家园 -->
          <el-menu-item :index="menuType.route_two">推荐线路2</el-menu-item>
          <!-- ：灵芝生态园→光耀美食街→石佛寺村民俗文化村→葡源农庄→张家大院→林枫生态园 -->
          <el-menu-item :index="menuType.route_three">推荐线路3</el-menu-item>
          <!-- ：西川特色产业示范村→乌沙塘红梅杏基地→龙泉甜瓜基地→马明手抓→永新村→红粉佳荣酒庄→移民旧址 -->
        </el-submenu>
        <el-menu-item :index="menuType.happy">
          <span slot="title">农家乐</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="content">
      <mapGD
        :selected-key="selectedKey"
        :modalConfigHandle="modalConfigHandle"
        ref="map"
        @initFinish="initFinis"
      ></mapGD>
    </div>
  </div>
</template>

<script>
import mapGD from "@/components/mapGD";
import Swiper2, { Navigation, Pagination, Autoplay } from "swiper";
Swiper2.use([Navigation, Pagination, Autoplay]);

export default {
  name: "industryChain",
  components: { mapGD },
  data() {
    return {
      menuType: {
        food: "1",
        special: "2",
        travel: "3",
        route_one: "3-1",
        route_two: "3-2",
        route_three: "3-3",
        happy: "4",
      },
      routeOneLine: [
        { keyword: "强家老醋文化养生园", city: "吴忠" },
        { keyword: "牛家坊村", city: "吴忠" },
        { keyword: "桃园农庄", city: "吴忠" },
        { keyword: "牛家大院", city: "吴忠" },
        { keyword: "依林小镇", city: "吴忠" },
        { keyword: "海军生态农家园", city: "吴忠" },
      ],
      routeTwoLine: [
        { keyword: "灵芝生态园", city: "吴忠" },
        { keyword: "葡源农庄", city: "吴忠" },
        { keyword: "光耀美食街", city: "吴忠" },
        { keyword: "张家大院", city: "吴忠" },
        { keyword: "林枫生态园", city: "吴忠" },
      ],
      routeThreeLine: [
        { keyword: "马明手抓", city: "吴忠" },
        { keyword: "永新村", city: "吴忠" },
        { keyword: "红粉佳荣酒庄", city: "吴忠" },
        { keyword: "移民旧址", city: "吴忠" },
      ],
      selectedKey: "1",
      foodMapList: [
        // 早茶
        {
          name: "香丁丁早茶文化体验馆",
          address: "吴忠市利通区万达广场东门10-15号营业房",
          lnglats: [106.1927, 37.993778],
          phone: "19995316777",
          icon: require("../assets/foodImages/icon_tea_1.png"),
        },
        {
          name: "香丁丁牛肉面馆两馆一中心店",
          address: "吴忠市利通区宏泰商业广场S一103号",
          lnglats: [106.163996, 37.98962],
          phone: "13139551188",
          icon: require("../assets/foodImages/icon_tea_2.png"),
        },
        {
          name: "吴忠市利通区泰盛轩特色菜馆",
          address: "宁夏回族自治区吴忠市利通区黎明街277号",
          lnglats: [106.188574, 37.993425],
          phone: "0953-2701777",
          icon: require("../assets/foodImages/icon_tea_3.png"),
        },
        {
          name: "吴忠市利通区老马记牛肉面馆",
          address: "宁夏回族自治区吴忠市利通区文卫南街康定达商城201号",
          lnglats: [106.203865, 37.992452],
          phone: "0953-2261777",
          icon: require("../assets/foodImages/icon_tea_4.png"),
        },
        // 手抓
        {
          name: "小叶凉手抓(裕民西路)",
          address: "吴忠市利通区裕民西街68号",
          lnglats: [106.197056, 37.985226],
          phone: "0953-2010892",
          icon: require("../assets/foodImages/icon_grab_1.png"),
        },
        {
          name: "正川手抓羊肉馆",
          address: "宁夏回族自治区吴忠市利通区朝阳街派出所附近",
          lnglats: [106.210517, 37.9834],
          phone: "0953-2029558",
          icon: require("../assets/foodImages/icon_grab_2.png"),
        },
        {
          name: "牛记手抓羊肉馆",
          address: "宁夏回族自治区吴忠市利通区胜利西路与黎明街交叉口西100米",
          lnglats: [106.19, 37.98],
          phone: "13519275858",
          icon: require("../assets/foodImages/icon_grab_3.png"),
        },
        {
          name: "回月斋羊肉馆",
          address: "宁夏回族自治区吴忠市利通区双拥路10号",
          lnglats: [106.2, 37.99],
          phone: "13519536984",
          icon: require("../assets/foodImages/icon_grab_4.png"),
        },
        // 羊杂碎
        {
          name: "老杜家羊杂碎",
          address: "吴忠市利通区双拥路76号盛世花园南门口",
          lnglats: [106.200983, 37.992643],
          phone: "13895213504",
          icon: require("../assets/foodImages/icon_sheep_1.png"),
        },
        {
          name: "杜优素羊杂碎",
          address: "宁夏回族自治区吴忠市利通区黎民街164号",
          lnglats: [106.188959, 37.989989],
          phone: "0953-227-6666",
          icon: require("../assets/foodImages/icon_sheep_2.png"),
        },
        {
          name: "羊杂碎(金星花园二区店)",
          address: "吴忠市利通区金星花园二区",
          lnglats: [106.207819, 37.988463],
          phone: "18709530867",
          icon: require("../assets/foodImages/icon_sheep_3.jpeg"),
        },
        {
          name: "马记砂锅羊杂碎",
          address: "宁夏回族自治区吴忠市利通区明珠路北侧特地商业广场C14号",
          lnglats: [106.197918, 37.998631],
          phone: "13909557780",
          icon: require("../assets/foodImages/icon_sheep_4.jpeg"),
        },
        // 拉面
        {
          name: "苏子拉面馆",
          address: "吴忠市利通区民和巷",
          lnglats: [106.195815, 37.985194],
          phone: "0953-2251777",
          icon: require("../assets/foodImages/icon_noodle_1.png"),
        },
        {
          name: "老何记早茶牛肉面(吴忠祥和大厦店)",
          address: "吴忠市利通区利宁北街503号",
          lnglats: [106.193074, 37.996093],
          phone: "19909531669",
          icon: require("../assets/foodImages/icon_noodle_2.png"),
        },
        {
          name: "满碗香牛肉拉面（金花园店）",
          address: "宁夏回族自治区吴忠市利通区花园街150号",
          lnglats: [106.203194, 37.99924],
          phone: "18695333358",
          icon: require("../assets/foodImages/icon_noodle_3.png"),
        },
        {
          name: "赵二拉面馆(金屋大厦店)",
          address: "吴忠市利通区新村街154号金屋大厦F1层",
          lnglats: [106.204442, 37.979709],
          phone: "13895553508",
          icon: require("../assets/foodImages/icon_noodle_4.png"),
        },
        // 烩小吃
        {
          name: "国富手抓餐饮名店(光耀店)",
          address: "吴忠市利通区东塔寺乡光耀美食城西门",
          lnglats: [106.21274, 38.010585],
          phone: "0953-2699999",
          icon: require("../assets/foodImages/icon_snack_1.png"),
        },
        
        {
          name: "老杨德福拉面总店",
          address: "吴忠市利通区利通北街552号",
          lnglats: [106.16,37.98],
          phone: "15595237297",
          icon: require("../assets/foodImages/icon_snack_3.png"),
        },
        {
          name: "点五酱牛骨烩三香",
          address: "宁夏回族自治区吴忠市利通区胜利西路467号",
          lnglats: [106.187159, 37.981145],
          phone: "18195316828",
          icon: require("../assets/foodImages/icon_snack_4.png"),
        },
      ],
      //特色产品
      featureMapList: [
        {
          name: "扁担沟苹果",
          address: "吴忠市利通区扁担沟镇	",
          intro: `扁担沟苹果，为农产品地理标志产品。产地范围为宁夏回族自治区吴忠市利通区扁担沟镇。由于严格按照有机苹果生产标准种植，生产的苹果色泽鲜艳，果肉香甜，口感上乘。
营养价值：苹果有“智慧果”、“记忆果”的美称。人们早就发现，多吃苹果有增进记忆、提高智能的效果。苹果不仅含有丰富的糖、维生素和矿物质等大脑必需的营养素，而且更重要的是富含锌元素。据研究，锌是人体内许多重要酶的组成部分，是促进生长发育的关键元素。锌通过酶广泛参与体内蛋白质、脂肪和糖的代谢。`,
          lnglats: [106.225123, 37.797702],
          phone: "0953-2611100",
          icon: require("../assets/foodImages/special_apple.png"),
        },
        {
          name: "涝河桥牛羊肉",
          address: "吴忠市利通区郭家桥乡涝河桥清真牛羊肉批发市场",
          intro: `宁夏涝河桥清真肉食品有限公司，现已形成了集牛、羊屠宰分割深加工为主、功能滋补型牛羊副产品为辅的大型清真肉食品企业和管理经营西北五省区最大的清真牛羊肉屠宰交易市场，建立起肉羊养殖、屠宰加工、清真休闲熟食加工等一系列的优质原料产地和便于研发的加工基地。`,
          lnglats: [106.237763, 37.962451],
          phone: "0953-2611100",
          icon: require("../assets/foodImages/special_meat.png"),
        },
        {
          name: "金银滩李子",
          address: "吴忠市利通区金银滩镇",
          intro: `金银滩李子饱满圆润，玲珑剔透，形态美艳，口味甘甜，是人们喜食的传统果品之一。它既可鲜食，又可以制成罐头、果脯，是夏季的主要水果之一。李子美味多汁，清肝热、活血脉，有美颜乌发的神效。但李子多食生痰，损坏牙齿，体质虚弱的患者宜少食。`,
          lnglats: [106.272418, 37.912393],
          phone: "0953-2611100",
          icon: require("../assets/foodImages/special_plum.png"),
        },
        {
          name: "宁夏甘草",
          address: "吴忠市利通区灵白村",
          intro: `宁夏素来就是甘草之乡。所产甘草历史源远，名盖西北，故又有“西镇甘草”、“西正草”之称。甘草为宁夏“五宝”之一。长期以来，西镇甘草与产自内蒙古草原的“梁外甘草”，齐名媲美，光耀中外，同为我国两路传统的甘草佳品。`,
          lnglats: [106.33815, 37.903839],
          phone: "0953-2611100",
          icon: require("../assets/foodImages/special_licorice.png"),
        },
      ],
      //景区推荐
      spotMapList: [
        {
          name: "牛家坊",
          address: "吴忠市利通区牛家坊",
          lnglats: [106.202714, 37.971818],
          phone: "0953-2611100",
        },
        {
          name: "强家老醋文化养生园",
          address: "吴忠市利通区利通区创业园41号",
          lnglats: [106.233049, 37.969903],
          phone: "0953-2611100",
        },
        {
          name: "光耀美食街",
          address: "吴忠市利通区利通北街101号省道光耀商贸城北门口",
          lnglats: [106.217043, 38.01008],
          phone: "0953-2611100",
        },
        {
          name: "董府",
          address: "吴忠市利通区金积镇露天洼子村",
          lnglats: [106.084471, 37.923216],
          phone: "0953-2611100",
        },
        {
          name: "黄河大峡谷",
          address: "吴忠市青铜峡市青铜峡镇游客中心",
          lnglats: [105.991775, 37.883645],
          phone: "0953-2611100",
        },
      ],
      //农家乐
      mapList: [
        {
          name: "白杨居农家乐",
          address: "吴忠市利通区牛家坊村八队味乡情休闲农庄",
          lnglats: [106.214773, 37.956515],
          phone: "13909556096",
          icon: require("../assets/foodImages/farmhouse_white.png"),
        },
        {
          name: "清水源丫丫农家乐",
          address: "吴忠市利通区利华南街与金积大道交叉口东南420米",
          lnglats: [106.220031, 37.962],
          phone: "19995338884",
          icon: require("../assets/foodImages/farmhouse_ya.png"),
        },
        {
          name: "朝夕农场",
          address: "吴忠市利通区新华桥村村民委西北侧100米",
          lnglats: [106.195447, 37.978837],
          phone: "13195076525",
          icon: require("../assets/foodImages/farmhouse_daynight.jpg"),
        },
        {
          name: "吴忠灵芝园生态园",
          address: "吴忠市利通区古城镇滨河大道东侧苦水河南侧交叉处",
          lnglats: [106.21163, 38.063665],
          phone: "18109535599",
          icon: require("../assets/foodImages/farmhouse_ganoderma.png"),
        },
      ],
    };
  },
  mounted() {},
  methods: {
    initFinis() {
      this.handleSelect(this.selectedKey);
    },
    modalConfigHandle(params) {
      const h = this.$createElement;
      const { name, address, phone, icon, intro } = params;
      const config = {
        name: name,
        content: h("div", null, [
          h("p", null, "地址: " + address),
          h("p", null, "电话: " + phone),
          this.selectedKey === this.menuType.special
            ? h("img", { attrs: { src: icon }, style: "width: 100%;" })
            : null,
          this.selectedKey === this.menuType.special
            ? h("p", null, "简介: " + intro)
            : null,
          // h("img", { attrs: { src: icon }, style: "width: 100%;" }),
          // h("p", null, "简介: " + intro),
        ]),
      };
      return config;
    },
    handleSelect(key) {
      this.selectedKey = key;

      if (
        key === this.menuType.route_one ||
        key === this.menuType.route_two ||
        key === this.menuType.route_three
      ) {
        const list = {
          [this.menuType.route_one]: this.routeOneLine,
          [this.menuType.route_two]: this.routeTwoLine,
          [this.menuType.route_three]: this.routeThreeLine,
        };
        const getLineList = list[key];
        this.$refs.map.drawRouteLines(getLineList);
      } else {
        const list = {
          [this.menuType.food]: this.foodMapList,
          [this.menuType.special]: this.featureMapList,
          [this.menuType.travel]: this.spotMapList,
          [this.menuType.happy]: this.mapList,
        };
        const getList = list[key];
        const menuTypeValue = Object.keys(this.menuType).find(
          (type) => this.menuType[type] === key
        );
        this.$refs.map.addMapPoints(getList, menuTypeValue);
      }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style scoped>
.industry {
  width: 100%;
  padding: 17px 0;
  display: flex;
  justify-content: center;
  /* align-items: center; */
}
.menu {
  width: 10%;
  padding-top: 5px;
  background: transparent;
}
.content {
  width: 83%;
}
::v-deep .el-menu {
  /* border-top: solid 3px #132538; */
  border-right: solid 1px transparent;
  list-style: none;
  position: relative;
  margin: 0;
  padding-left: 0;
  background-color: transparent;
  /* color: blueviolet; */
}
::v-deep .el-submenu__title {
  font-size: 14px;
  color: #fff;
  padding: 0 20px;
  cursor: pointer;
  /* transition: border-color .3s,background-color .3s,color .3s; */
  box-sizing: border-box;
  background-color: transparent;
}
::v-deep .el-menu-item {
  color: #fff;
  /* transition: border-color .3s,background-color .3s,color .3s; */
  box-sizing: border-box;
  white-space: nowrap;
  background-color: transparent;
}
::v-deep .el-menu-item.is-active {
  color: #399dfe;
}
::v-deep .el-submenu .el-menu-item {
  height: 50px;
  line-height: 50px;
  padding: 0 45px;
  min-width: 150px;
  background-color: transparent;
}
::v-deep.amap-marker-label {
  position: absolute;
  z-index: 2;
  border: none;
  background-color: #fff;
  white-space: nowrap;
  cursor: default;
  padding: 3px;
  font-size: 12px;
  line-height: 14px;
}
</style>
